<template>
  <div class="project" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="案例详情" :showBack="true"></my-header>
    <div class="case-info-detail" :style="caseProject.foremanId?bluestyleObject:bluestyleObject">
      <div class="project-info">
        <div>{{caseProject.name}}</div>
      </div>
      <div class="project-house-type">
        {{caseProject.area}}㎡&nbsp;&nbsp;|&nbsp;&nbsp;{{caseProject.houseLayout}}
      </div>
    </div>
    <div v-if="caseProject.foremanId" @click="openPersonDetail(foreman)" class="supervisor-info">
      <img class="supervisor-avatar" :src="imgUrl + foreman.avatar">
      <div class="supervisor-less-info">
        <div>工长<span class="supervisor-name">{{foreman.name}}</span></div>
        <div class="supervisor-auth">
          <div class="platform-auth"><img src="../../assets/appointment/icon-platform-auth.png"/> <div>平台认证</div></div>
          <div class="supervisor-deposit"><img src="../../assets/appointment/icon-deposit-auth.png"/><div>9 万</div></div>
        </div>
      </div>
      <div class="evaluate-score">
        <div class="score">{{foreman.score | score}}</div>
        评分
      </div>
    </div>
    <div v-if="caseProject.supervisorId || caseProject.designerId" @click="openPersonDetail(supervisor)" class="supervisor-info">
      <img class="supervisor-avatar" :src="imgUrl + supervisor.avatar">
      <div class="supervisor-less-info">
        <div>
          <span v-if="supervisor.type == '1'">监理</span>
          <span v-if="supervisor.type == '5'">设计师</span>
          <span class="supervisor-name">{{supervisor.name}}</span>
        </div>
        <div class="supervisor-auth" style="width: 2.27rem">
          <div class="platform-auth"><img src="../../assets/appointment/icon-platform-auth.png"/> <div>平台认证</div></div>
        </div>
      </div>
      <div class="evaluate-score">
        <div class="score">{{supervisor.score | score}}</div>
      </div>
    </div>
    <div class="work-progress" v-if="caseProject.type=='2'">
      <div style="display: flex;justify-content:flex-start;">
        <div class="wp-title" @click="changeTabSelect('1')" :class="{'selected': tabItemSelect == '1'}">施工进度</div>
        <!-- <div class="wp-title" @click="changeTabSelect('2')" :class="{'selected': tabItemSelect == '2'}">施工图片</div> -->
      </div>
      <div class="wp-body general-box-shadow" v-if="tabItemSelect == '1'">
        <div class="wp-row" v-for="(stage,index) in projectStage" v-n9of="stage.type != '0'">
          <div class="wp-label" :class="{'active': index <= imageIndexs}"><div :class="{'wp-label-border': index <= imageIndexs,'bordernoblue':index===projectStage.length-1}"></div></div>
          <div class="wp-content" :class="{'complete': index <= imageIndexs}">
            <div  @click="toggleNodes(stage.id)">
              <div class="stage-title" style="display: flex;justify-content: space-between">
                <div>{{stage.stageName}}</div>
                <img v-if="!stageMap[stage.id] && stage.projectPatrols[0][0]"  src="../../assets/icon/icon-pull-down.png">
                <img v-if="stageMap[stage.id] && stage.projectPatrols[0][0]"  src="../../assets/icon/icon-pull-up.png">
              </div>
              <div v-if="index <= imageIndexs" class="wp-date">{{stage.completeTime | simpleDayFilter}}</div>
            </div>
            <div v-if="stage.projectPatrols.length>0" class="category-list" style="display:flex;flex-flow: wrap;margin-top: 0.2rem;" v-for="category in stage.projectPatrols[0]" v-show="stageMap[stage.id]">
                <img  v-for="(img,index) in category.attachmentList" :key="index" style="margin-right:0.1rem;margin-bottom:0.15rem;border-radius:0.13rem;width:1.9rem;height:1.9rem;object-fit: fill;" :src="imgUrl+ img" @click="previewImg(img,category.attachmentList)">
                <!-- <img  v-for="(img,index) in category.attachmentList" :key="index" style="margin-right:0.15rem;margin-bottom:0.15rem;border-radius:0.13rem;width:1.9rem;height:1.9rem;object-fit: fill;" :src="imgUrl+ img | ossProcess(170, 170)" @click="previewImg(img,projectNode.nodeImageArray)"> -->
            </div>
          </div>
        </div>
      </div>
      <div class="wp-body" v-if="tabItemSelect == '2'">
        <div class="no-image" v-if="projectImageList.length ==0 && completeImgList.length == 0">
          <img src="../../assets/icon-no-img.png">
          <div class="tip">暂无施工图片~</div>
        </div>
        <div v-if="caseProject.isExample == '1' && caseProject.completeImages" style="margin-left: 0.3rem">
          <div class="foreman-img-list">
            <div v-for="(recoredImg,index) in completeImgList">
              <img class="foreman-img" :src="recoredImg.imagePath" @click = "previewImg(recoredImg.imagePath,projectImg.attachmentList)">
            </div>
          </div>
        </div>
        <div v-if="caseProject.isExample != '1'" v-for="projectImg in projectImageList" style="margin-left: 0.3rem">
          <div class="img-title" style="margin-top: 0.2rem;font-size: 0.36rem;color: #191818;">
            <div>{{projectImg.type | projectImageTypeConvert}}</div>
          </div>
          <div class="foreman-img-list">
            <div v-if="projectImg.attachmentList.length>0 && projectImg.images" v-for="(recoredImg,index) in projectImg.attachmentList">
              <img class="foreman-img" :src="imgUrl+recoredImg" @click = "previewImg(recoredImg,projectImg.attachmentList)">
            </div>
            <div v-if="!projectImg.images" class="no-image">
              <img src="../../assets/icon-no-img.png">
              <div class="tip">暂无相关施工图~</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="work-progress" v-if="caseProject.type=='6'">
      <div class="wp-title selected">效果图</div>
      <div class="wp-body general-box-shadow selected-body">
        <div class="no-image" v-if="renderings.length==0">
          <img src="../../assets/icon-no-img.png">
          <div class="tip">暂无效果图展示~</div>
        </div>
        <div v-if="renderings.length>0" v-for="completeImg in renderings">
          <img :src="imgUrl+ completeImg" style="width: 100%;border-radius: 0.06rem;margin-bottom: 0.1rem;" @click="previewImg(completeImg,renderings)">
        </div>
      </div>
    </div>
    <div class="work-progress" v-if="caseProject.type=='1'||caseProject.type=='5'">
      <div class="wp-title selected">监理验收</div>
      <div class="wp-body general-box-shadow" :class="{'selected-body': tabItemSelect == '1'}">
        <div class="wp-row" v-for="stage in projectStage" v-if="stage.type != '0'">
          <div class="wp-label" :class="{'active': stage.status === '3'}"><div :class="{'wp-label-border': stage.status === '3'}"></div></div>
          <div class="wp-content" :class="{'complete': stage.status === '3'}">
            <div  @click="toggleNodes(stage.id)">
              <div class="stage-title" style="display: flex;justify-content: space-between">
                <div>{{stage.stageName}}</div>
                <img v-if="!stageMap[stage.id]"  src="../../assets/icon/icon-pull-down.png">
                <img v-if="stageMap[stage.id]"  src="../../assets/icon/icon-pull-up.png">
              </div>
              <div v-if="stage.status === '3'" class="wp-date">{{stage.inspectTime | simpleDayFilter}}</div>
            </div>
            <div v-if="stage.categoryList && stage.categoryList.length>0" class="category-list" v-for="category in stage.categoryList" v-show="stageMap[stage.id]">
              <span class="category-name" style="padding-left:0;width: 3.2rem;height: 1.5rem;">{{category.name}}</span>
              <div v-for="projectNode in category.onestopProjectNodeList" class="node-list">
                <div style="display: flex;">
                  <div>{{projectNode.nodeNumber}}.</div>
                  <div class="node-content">{{projectNode.nodeContent}}</div>
                  <img style="width: 0.32rem;height: 0.32rem" v-if="projectNode.score == '7'" src="../../assets/onestop/icon-node-qualified.png">
                  <img style="width: 0.32rem;height: 0.32rem"  v-if="projectNode.score != '7'" src="../../assets/onestop/icon-node-unqualified.png">
                </div>
                <div v-if="projectNode.nodeImageArray && projectNode.nodeImageArray.length>0" class="node-img-list">
                  <img v-for="img in projectNode.nodeImageArray" :src="imgUrl+ img | ossProcess(170, 170)" @click="previewImg(img,projectNode.nodeImageArray)">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
  .clear-header{
    margin-top: -1rem;
  }
  .project{
    background-color: white;
    font-size: 0.36rem;
    .general-box-shadow{
      border-radius: 0.08rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem
      rgba(0, 0, 0, 0.1);
    }
    .no-image{
      text-align: center;
      img{
        width: 1.57rem;
        height: 1.57rem;
      }
      .tip{
        margin-top: 0.4rem;
        font-size: 0.28rem;
        color: #7f7d7c;
      }
    }
    .case-info-detail{
      height: 1.7rem;
      background: #364157;
      color: white;
      .project-info{
        padding-top: 0.37rem;
        padding-left: 0.33rem;
        line-height: 0.34rem;
        font-size: 0.42rem;
        font-weight: bold;
      }
      .project-house-type{
        margin-top: 0.26rem;
        margin-left: 0.33rem;
        line-height: 0.34rem;
        font-size: 0.3rem;
        color: white;
      }
    }
    .supervisor-info{
      display: flex;
      width: 6.82rem;
      height: 1.93rem;
      margin: 0.3rem auto 0;
      background-color: #f8f8f8;
      border-radius: 0.1rem;
      .supervisor-avatar{
        width: 1.3rem;
        height: 1.3rem;
        border-radius: 0.06rem;
        margin: 0.3rem 0.28rem 0.3rem 0.2rem;
      }
      .supervisor-less-info{
        margin-top: 0.4rem;
        font-size: 0.28rem;
        color: #7f7d7c;
        .supervisor-name{
          margin-left: 0.2rem;
          font-weight: bold;
          font-size: 0.36rem;
          color: #191818;
        }
        .supervisor-auth{
          display: flex;
          width: 3.24rem;
          height: 0.4rem;
          line-height: 0.45rem;
          border-radius: 0.04rem;
          margin-top: 0.22rem;
          background: #e8eff7;;
          font-size: 0.26rem;
          color: #00478e;
          img{
            width: 0.27rem;
            height: 0.28rem;
            margin-top: 0.06rem;
            margin-right: 0.1rem;
          }
          .platform-auth{
            display: flex;
            padding-left: 0.23rem;
          }
          .supervisor-deposit{
            display: flex;
            padding-left: 0.29rem;
          }
        }
      }
      .evaluate-score{
        position: absolute;
        right: 1rem;
        background: url("../../assets/icon-score-bg.png") no-repeat;
        width: 1rem;
        height: 0.8rem;
        margin-top: 0.45rem;
        line-height: 0.25rem;
        background-size: 100%;
        font-size: 0.18rem;
        color: white;
        text-align: center;
        .score{
          width: 0.74rem;
          height: 0.3rem;
          margin-top: 0.08rem;
          margin-left: 0.3rem;
          font-size: 0.24rem;
          font-weight: bold;
          color: #e07070;
        }
      }
    }
    .work-progress{
      padding-left: 0.3rem;
      padding-bottom: 0.5rem;
      .wp-title{
        height: 1.05rem;
        line-height: 1.1rem;
        margin-right: 0.3rem;
        color: #191818;
        font-size: 0.32rem;
      }
      .selected{
        font-weight: bold;
      }
      .wp-body{
        width: 6.9rem;
        padding-top: 0.33rem;
        padding-bottom: 0.6rem;
        box-shadow: 0rem 0.02rem 0.07rem 0rem
        rgba(0, 0, 0, 0.1);
        .node-img-list{
          display: flex;
          flex-wrap: wrap;
          width: 6rem;
          img{
            display: block;
            width: 1.75rem;
            height: 1.75rem;
            margin-top: 0.2rem;
            margin-right: 0.2rem;
          }
        }
        .foreman-img-list{
          width: 6.3rem;
          .foreman-img{
            display: block;
            max-width: 100%;
            margin-top: 0.2rem;
          }
        }
      }
      .none-complete-img{
        font-size: 0.28rem;
        color: #d5dee2;
        padding-top: 1.73rem;
        text-align: center;
        img{
          width: 0.72rem;
          height: 0.6rem;
        }
      }
       .wp-row >>> .wp-label{
         height: 100%;
         border-left: solid 1rpx #00478e;
       }
      .wp-row{
        padding-left: 0.2rem;
        margin-top: 0.6rem;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        .wp-label{
          position: relative;
          width: 0.36rem;
          margin-top: 0.05rem;
          background: url("../../assets/icon/icon-stage-uncomplete.png") no-repeat;
          background-size: 100%;
          flex-grow: 0;
          flex-shrink: 0;
          .wp-label-border{
            position: absolute;
            height: 100%;
            top:0.45rem;
            left:0.16rem;
            border-left: 1px solid #00478e;
        }
        .bordernoblue{
            position: absolute;
            height: 100%;
            top:0.45rem;
            left:0.16rem;
            border-left: none;
        }
          &.active{
            width: 0.36rem;
            // height: 100%;
            margin-top: 0.05rem;
            background: url("../../assets/icon/icon-stage-complete.png") no-repeat;
            background-size: 100%;
            // border-left: solid 1rpx #00478e;
          }

        }
        &:first-child{
         margin-top:0px;
        }
        .wp-content{
          margin-left: 0.2rem;
          color: #7f7d7c;
          font-size: 0.32rem;
          font-weight: bold;
          flex-grow: 1;
          flex-shrink: 0;
          &.complete{
            color: #191818;
          }
          .wp-date{
            font-weight: normal;
            font-size: 0.24rem;
            color: #cecbca;
          }
          .stage-title{
            display: flex;
            justify-content: space-between;
            img{
              width: 0.34rem;
              height: 0.2rem;
              margin-right: 0.3rem;
            }
          }
          .category-list{
            width: 6.0rem;
            .category-name{
              // display: inline-block;
              margin: 0.1rem 0.1rem 0.2rem 0.1rem;
              // margin-top: 0.1rem;
              // margin-bottom: 0.2rem;
              // padding: 0.1rem 0.3rem;
              background-color: #f3f9ff;
              border-radius: 4px;
              font-size: 0.24rem;
              color: #00478e
            }
            .node-list{
              margin-bottom: 0.3rem;
              color: #7f7d7c;
              font-size: 0.28rem;
              font-weight: lighter;
              .node-content{
                width: 5.26rem;
                line-height: 0.4rem;
                text-align: justify;
                margin-right: 0.4rem;
              }
            }
          }
        }
      }
    }
  }
</style>

<script>
  import {imgUrl,shareIcon} from '../../config'
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import ProjectService from '../../service/customer/ProjectService'
  import SupervisorService from '../../service/SupervisorService'
  import EvaluateService from '../../service/customer/EvaluateService'
  import shareService from '../../service/share/ShareService'
  import companyService from '../../service/company/CompanyService'
  import evaluateService from '../../service/customer/EvaluateService'
  import onestopProjectService from '../../service/onestop/OnestopProjectService';

  export default {
    name: 'Project',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imageIndexs:'',
        caseProject:{},
        foreman:{},
        supervisor:{},
        projectStage:[],
        stage:{},
        imgUrl:imgUrl,
        shareIcon:shareIcon,
        customerEvaluateList:[],
        isWechatBrowser:this.$verfyBrowserType(),
        projectName:'',
        tabItemSelect: '1',
        completeImgList:[],
        renderings:[],
        projectImageList:[],
        companyInfo:{},
        companyEvaluate:{},
        caseProjectId:'',
        stageMap:{},
        styleObject: {
          background: '#c4a183'
        },
        bluestyleObject: {
          background: '#384157'
        },
        allimagesss: [],
      }
    },
    created(){
      this.projectName = this.$route.query.projectName;
      this.caseProjectId = this.$route.query.id;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getCaseDetail(this.caseProjectId);
      this.initWechatShare();
    },
    methods: {
      changeTabSelect(select){
        this.tabItemSelect = select;
      },
      openPersonDetail(person){
        if(person.type == '2'){
          this.$router.push({name:'GangmasterDetail',query:{supervisorId:person.id}});
        }else if(person.type == '1'){
          this.$router.push({name:'SupervisorDetail',query:{supervisorId:person.id}});
        }else if(person.type == '5'){
          this.$router.push({name:'DesignerDetail',query:{supervisorId:person.id,supervisorName:person.name}});
        }
      },
      toOnestopCompany(companyId){
        this.$router.push({name:'OnestopCompany',query:{companyId}});
      },
      async getCaseDetail(id){//案例详情
        var result=await ProjectService.getOnestopProjectDetail(id);
        if(result.code == 0){
          this.caseProject = result.data;
          console.info(this.caseProject)
          if(this.caseProject.isExample != '1' && (this.caseProject.type == '2' || this.caseProject.type == '5')){
           this.getProjectImageList(this.caseProjectId);
            this.caseProject.completeImageList = [];
          }
          if(this.caseProject.foremanId){
            this.getForemanInfo(this.caseProject.foremanId);
            if(!this.caseProject.supervisorId){
              this.getProjectStage(this.caseProject.id,this.caseProject.foremanId);
            }
          }
          if(this.caseProject.supervisorId){
            this.getSupervisorInfo(this.caseProject.supervisorId);
            this.getProjectStage(this.caseProject.id,this.caseProject.supervisorId);
          }
          if(this.caseProject.designerId){
            this.getSupervisorInfo(this.caseProject.designerId);
          }
          if(this.caseProject.type == '5'){
            this.getCompanyInfo(this.caseProject.companyId);
            this.getCompanyEvaluate(this.caseProject.companyId);
          }
          if(this.caseProject.isExample != '1'){
            this.getEvaluateList();
          }
          console.info('this.caseProject',this.caseProject)
          if(this.caseProject.completeImages){
            console.info('this.caseProject.completeImages',this.caseProject.completeImages)
            let completeImageArray = this.caseProject.completeImages.split(',');
            let completeImage ={};
            for(let image of completeImageArray){
              completeImage = {imagePath:imgUrl+image};
              this.completeImgList.push(completeImage);
            }
          }
          if(this.caseProject.renderings){
            this.renderings = this.caseProject.renderings.split(',');
          }
        }else {
          Toast('获取案例项目详情信息失败');
        }
      },
      async getCompanyInfo(id){
        let {code,data:companyInfo} = await companyService.getCompanyInfo(id);
        if(code == 0){
          this.companyInfo = companyInfo;
        }else {
          Toast('获取整包公司信息失败');
        }
      },
      async getCompanyEvaluate(companyId){
        var result = await evaluateService.getCompanyEvaluate(companyId);
        if(result.code == 0){
          this.companyEvaluate = result.data;
        }else {
          Toast('获取整包公司评价信息失败');
        }
      },
      async getForemanInfo(id){
        var result=await SupervisorService.getSupervisorDetail(id);
        if(result.code == 0){
          this.foreman=result.data;
        }else {
          Toast('获取工长详细信息失败');
        }
      },
      async getSupervisorInfo(id){
        var result=await SupervisorService.getSupervisorDetail(id);
        if(result.code == 0){
          this.supervisor=result.data;
        }else {
          Toast('获取监理详细信息失败');
        }
      },
      async getProjectStage(id,supervisorId){
        var result=await ProjectService.getOnestopProjectStage(id,supervisorId);
        if(result.code == 0){
          this.projectStage=result.data.stageList;
          const status3 = JSON.parse(JSON.stringify(result.data.stageList));
          status3.reverse()
          const indexstatus = status3.findIndex((item)=>{
            return item.status === '3'

          })
          console.log('323123123',indexstatus)
          this.imageIndexs = indexstatus == '-1'?0:this.projectStage.length-1-indexstatus
          console.log('imageIndexs',this.imageIndexs)


          // const allimagelistss = []
          // console.log('工长',this.projectStage)
          // console.log('工长123',this.projectImageList)
          // const ll = result.data.stageList.forEach((item,index)=>{
          //   const imagelistss = this.projectImageList.filter(i=>index+1==i.type)
          //   allimagelistss.push(imagelistss)
          // })
          // this.allimagesss = allimagelistss
          // console.log('工长123321',this.allimagesss)
          this.projectStage.forEach((item,index)=>{
            item.projectPatrols.push(this.projectImageList.filter(i=>index+1==i.type))
          })
          if(this.caseProject.type == '1'){
            this.getProjectNodeList()
          }
          console.info(this.projectStage)
        }else {
          Toast('获取工地验收进度信息失败');
        }
      },
      async getProjectNodeList(){
        for (let stage of this.projectStage){
          if(stage.status == '2' || stage.status == '3'){
            this.$set(this.stageMap, stage.id, false);
            let {code,data:nodeList} = await onestopProjectService.nodeList(this.caseProject.id,stage.stageId);
            this.$set(stage,'categoryList',nodeList.categoryList);
            for (let category of nodeList.categoryList) {
              console.info('category',category)
              let nodeImageArray = [];
              for(let node of category.onestopProjectNodeList){
                if(node.recordImages){
                  nodeImageArray = node.recordImages.split(',');
                }
                this.$set(node,'nodeImageArray',nodeImageArray);
              }
            }
          }else {
            this.$set(stage,'categoryList',[]);
          }
        }
      },
      async getEvaluateList(){
        var result = await EvaluateService.evaluateList('','',this.caseProject.id,this.caseProject.type);
        if(result.code == 0){
          this.customerEvaluateList = result.data;
          for (let evaluate of this.customerEvaluateList) {
            if(!evaluate.customerUser.nickname && !evaluate.customerName){
              evaluate.customerName = evaluate.onestopProject.customerName;
            }
          }
        }else {
          Toast('获取工长评价信息失败');
        }
      },
      toggleNodes(id){
        this.$set(this.stageMap, id, !this.stageMap[id]);
        console.info(this.stageMap);
      },
      async initWechatShare(){
        let title = this.projectName;// 分享标题
        let desc = "水木家居商城真实案例"; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      async getProjectImageList(projectId){
        var result = await ProjectService.getProjectImageList(projectId);
        console.info('result.data',result.data)
        if(result.code == 0 && result.data){
          for (let projectImg of result.data){
            let pi = this.projectImageList.find(item => item.type == projectImg.type)
            if(!pi) {
              pi = projectImg
              pi.attachmentList = new Set()
              this.projectImageList.push(pi)
            }
            projectImg.images.split(',').forEach(img => {
              pi.attachmentList.add(img);
            })
          }
        }else {
          Toast('获取工地实拍信息失败');
        }
      },
      previewImg(currentImage,imageList){
        let previewImageList = [];
        for (let image of imageList){
          let previewImage = this.imgUrl + image;
          previewImageList.push(previewImage);
        }
        wx.previewImage({
          current: currentImage,
          urls: previewImageList
        });
      },
      previewFullImg(currentImage,imageList){
        wx.previewImage({
          current: currentImage,
          urls: imageList
        });
      },
    }
  }
</script>

